module.exports = __webpack_public_path__ + "media/images/countrysquared/is-ac41d957a182fa5ea3472f73b955d83c.svg";